<template src="./FeedbackDetails.html"></template>

<script>
import { answeredCount, isSubjectComplete } from "../utils/responses";

export default {
  name: "FeedbackDetails",

  props: {
    fullName: { type: String, default: "" },
    prn: { type: String, default: "" },
    department: { type: String, default: "" },
    courseYear: { type: String, default: "" },
    batch: { type: String, default: "" },
    academicYear: { type: String, default: "" },
    semName: { type: String, default: "" },
    formType: { type: String, default: "" },
    formTitle: { type: String, default: "" },
    formDescription: { type: String, default: "" },
    isCourseFeedback: { type: Boolean, default: false },
    subjects: { type: Array, default: () => [] },
    nextIndex: { type: Number, default: 0 },
  },

  computed: {
    firstName() {
      return this.fullName || "Student";
    },

    // Recruiters are anonymous (no name), so greet them without "Student".
    welcomeTitle() {
      return this.formType === "Recruiter Feedback"
        ? "Welcome"
        : `Welcome, ${this.firstName}`;
    },

    subtitle() {
      return this.isCourseFeedback
        ? `You have ${this.subjects.length} subjects to review. Your responses are anonymous.`
        : "Your responses are anonymous.";
    },
    isProgramFeedback() {
      return this.formType === "Program Feedback";
    },

    chips() {
      const values = this.isProgramFeedback
        ? [this.prn, this.batch]
        : [this.prn, this.batch, this.department, this.courseYear];
      return values.filter(Boolean);
    },

    programRows() {
      const rows = [
        { label: "Feedback name", value: this.formTitle },
        { label: "Academic year", value: this.academicYear },
      ];
      if (!this.isProgramFeedback) {
        rows.push(
          { label: "Semester", value: this.semName },
          { label: "Department", value: this.department }
        );
      }
      return rows.filter((row) => row.value);
    },
  },

  methods: {
    answeredCount(subject) {
      return answeredCount(subject.questions);
    },

    isComplete(subject) {
      return isSubjectComplete(subject);
    },

    ringOffset(subject) {
      const total = subject.questions.length || 1;
      return 57 - (57 * this.answeredCount(subject)) / total;
    },

    cardClass(subject, index) {
      if (this.isComplete(subject)) return "details__card--complete";
      if (index === this.nextIndex) return "details__card--next";
      return "";
    },

    // The card is read-only now, so the label states where the subject stands
    // rather than inviting a click ("Start" / "Continue").
    statusLabel(subject) {
      return this.isComplete(subject) ? "Complete" : "Pending";
    },

    statusClass(subject) {
      return this.isComplete(subject)
        ? "details__status--complete"
        : "details__status--pending";
    },
  },
};
</script>

<style src="./FeedbackDetails.css" scoped></style>
